$('.color-swatch').mouseover(function () {
  $(this).addClass('is_able');
  $(this).siblings().removeClass('is_able')
})



$(document).on('scroll', function () {

  var obj = $('.open_path');
  if (obj.length > 0) {
    var clientHeight = $(window).height();
    var scrollTop = $(document).scrollTop();
    var offsetTop = obj.offset().top;
    var objHeight = obj.height();
    if (offsetTop + 100 < scrollTop + clientHeight && offsetTop + objHeight > scrollTop) {
      $('.huangquan').addClass('path');
    } else {
      $('.huangquan').removeClass('path');
    }
  }
})


// $('.variant-wrapper--dropdown select').change(function(){
//   var size_text=$(".variant-wrapper--dropdown select option:selected").text();
//   $('#VariantsizeLabel').text(size_text);
// });

$(document).ready(function () {
  $("#custom-faqs .title").click(function () {
    let imgArr = {
      open: "https://cdn.shopify.com/s/files/1/0506/8934/3650/files/plus.svg?v=1605234007",
      close: 'https://cdn.shopify.com/s/files/1/0506/8934/3650/files/Minus_sign.svg?v=1605234007'
    }
    $("#custom-faqs").children().each(function () {
      if (!($(this).find(".content").is(":hidden"))) {
        if ($(this).find("img").length > 1) {
          $(this).find("img").first().attr("src", imgArr.open);
        } else {
          $(this).find("img").attr("src", imgArr.open);
        }
        $(this).find(".content").slideUp(300);
      }
    })
    if ($(this).parent().find(".content").is(":hidden")) {
      $(this).find("img").attr("src", imgArr.close);
      $(this).parent().find(".content").slideDown(300);
    }
  });
  if ($(".swiper-height").length > 0) {
    var info = $(".swiper-height .grid-product__image-mask").height() / 2 + 20;
    $('.swiper-height .flickity-button').css('top', info + 'px')
  }
})


function copyUrl2() {
  var Url2 = document.getElementById("discount_code").innerText;
  document.getElementById("change_copy_close").click()
  var oInput = document.createElement('input');
  oInput.value = Url2;
  document.body.appendChild(oInput);
  oInput.select();
  document.execCommand("Copy");
  oInput.className = 'oInput';
  oInput.style.display = 'none';
}